import { Fragment, ReactNode, createElement, useEffect } from 'react';

type KeyShortcutsWrapperProps = {
  children: ReactNode;
};

const KeyShortcutsWrapper = ({ children }: KeyShortcutsWrapperProps) => {
   
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const key = event.key.toLowerCase();
      const isShortcutKey = event.ctrlKey || event.metaKey;

      if (isShortcutKey && key === 'd') {
        event.preventDefault();
       window.location.href = '/';
      }

      if (isShortcutKey && key === 'p') {
            window.location.href = '/product';
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return createElement(Fragment, null, children);
};

export default KeyShortcutsWrapper;